import { SubscriptionData } from "src/app/subscription/subscriptionUtils";
import { WsExtension } from "./extension";

interface WorkspacePermissions {
  workspace: string[];
}
interface WorkspaceDictionaryListItem {
  wsDictionaryUuid: string;
  wsDictionaryName: string;
  wsDictionaryElementName: null | string;
  wsDictionaryUrl: null | string;
  wsDictionaryIcon: null | string;
}

interface Avatar {
  id: string;
  parentUuid: string;
  name: string;
  mimeType: string;
  downloadUrl: string;
  publicUrl: string;
  thumbnails: {
    tiny: string;
    small: string;
    big: string;
  };
  rank: string;
  isRemovable: boolean;
}

interface TrialLimits {
  campaignsLimit: number;
  daysLimit: number;
  listsLimit: number;
  searchRequestsLimit: number;
  tasksLimit: number;
}

interface JwtTokenExpiresAt {
  date: string;
  timezone_type: number;
  timezone: string;
}

interface JwtToken {
  token: string;
  expiresAt: JwtTokenExpiresAt;
}

export enum SidebarItemType {
  System = "system",
  Dictionary = "wsDictionary",
}

export type SidebarItem = SystemSidebarItem | DictionarySidebarItem;

export interface SystemSidebarItem {
  type: SidebarItemType.System;
  key: `front_sidebar_item_${string}`;
  children?: SystemSidebarItem[];
}

export interface DictionarySidebarItem {
  type: SidebarItemType.Dictionary;
  wsDictionaryUuid: string;
  wsDictionaryName: string;
  wsDictionaryDescription: string;
  wsDictionaryElementName: string;
  wsDictionaryUrl: string;
  wsDictionaryIcon: string;
  wsDictionaryShowInGlobalCreator: boolean;
  wsDictionaryShowInSidebar: boolean;
}

export interface Identity {
  id: string;
  name: string;
  email: string;
  avatarUrl: string;
  lastWorkspaceUuid: string;
  errors: string[];
  memberRole: string | null;
  permissions: WorkspacePermissions;
  allowedEmailDomains: string[];
  trialLimits: TrialLimits;
  subscriptionData: SubscriptionData | null;
  isClient: boolean | null;
  magicLinkLoginUrl: string | null;
  showTrialLanguage: boolean;
  websocketChallenge: number;
  avatar: Avatar | null;
  chatwootId: null | { id: string; hash: string; token: string };
  wsWorkspaceExtensions: WsExtension[];
  isWorkspaceHostnameCustomized: boolean;
  wsCouponWebhookUrl: string;
  wsCouponShopifyWebhookUrl: string;
  wsCouponClientId: string;
  sentimentsAvailability: boolean;
  contactDataVisibilityEnabled: boolean;
  maxCreatorsForSendingMessage?: number | null;
  wsWorkspace: {
    name: string;
    logo: string | null;
    smallLogo: string | null;
    customPrimaryColor?: `#${string}`;
  };
  wsExtensionXtrmPaymentsUuid: string | null;
  wsExtensionAutoIncrementPaymentTitles: string | null;
  hasAccessToSendMessage: boolean;
  sidebarItems: SidebarItem[];
  workspaceDictionaryList: WorkspaceDictionaryListItem[];
  demoWsWorkspaceUrl?: string;
  isDemoWorkspace?: boolean;
  isAudienceOverlapEnabled?: boolean;
  isWsAiMetaValueServiceEnabled: boolean;
  isCreatorSearchEnabled: boolean;
  briefWsGlobalMetaFieldUuid: string;
  jwtToken: JwtToken;
}
